import Routers from './route';
import { RecoilRoot } from 'recoil';

function App() {
    return (
        <RecoilRoot>
            <Routers />
        </RecoilRoot>
    );
}

export default App;
